const LargeArrowUpIcon = () => {
  return (
    <svg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M1.65667 8.645L7 3.30167L12.355 8.645L14 7L7 0L0 7L1.65667 8.645Z' fill='#444D4E' />
    </svg>
  )
}

export default LargeArrowUpIcon
